"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWebCreateZakatPaymentResponse = exports.isMobileCreateZakatPaymentResponse = exports.SupportedCurrencyTypes = exports.CASH_IN_ISA_KEY = exports.CASH_IN_HAND_KEY = void 0;
exports.CASH_IN_HAND_KEY = "CASH_IN_HAND";
exports.CASH_IN_ISA_KEY = "CASH_IN_ISA";
exports.SupportedCurrencyTypes = ["GBP", "USD", "EUR", "INR", "AED", "MYR", "CAD"];
// Type guard functions
const isMobileCreateZakatPaymentResponse = response => {
  return "paymentIntent" in response;
};
exports.isMobileCreateZakatPaymentResponse = isMobileCreateZakatPaymentResponse;
const isWebCreateZakatPaymentResponse = response => {
  return "sessionId" in response;
};
exports.isWebCreateZakatPaymentResponse = isWebCreateZakatPaymentResponse;